export const ds_AccordionBlock_Entry = `
    fragment ds_AccordionBlock_Entry on ds_AccordionBlock_Entry {
        id
        canonicalUid

        accordion_ColorPalette
        accordion_ColorTheme
        accordion_TopSpacing
        accordion_ContainerWidth
        accordion_FullWidthBackground

        accordion_AccordionStyle
        accordion_AccordionItems {
            ... on ds_AccordionItem_Entry {
                accordionItem_Icon {
                    name
                    set
                    type
                }
                accordionItem_BodyContent
                accordionItem_Heading
            }
        }
    }
`